/* 🤖 this file was generated by svg-to-ts */
export const nsArrowLeft: {
  name: 'arrow_left';
  data: string;
} = {
  name: 'arrow_left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path d="M8.15 16.7 2.45 11l5.7-5.7 1.33 1.33-3.42 3.42h13.49v1.9H6.06l3.42 3.42-1.33 1.33Z"/></svg>`
};
